import type { Person, StorePersonRequest } from './person';
import { Address } from '@lib/api/models/address';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ContactNumber, StoreContactNumberRequest } from '@lib/api/models/contact-numbers';
import { Package } from '@lib/api/models/package';

export interface Client {
    id: string;

    person_id: string;
    reference: string;
    nhs_number: string;
    email: string;
    status: boolean;

    created_at: string;
    updated_at: string;

    packages: Package[];
    person: Person;
    address: Address;
    contact_numbers: ContactNumber[];
}

export interface ClientAddress {
    id: string;
    reference: string;
    person: {
        initials: string;
        id: string;
        title: string;
        given_name: string;
        family_name: string;
        address: {
            id: string;
            street_1: string;
            post_code: string;
            lat: string;
            lng: string;
        }
    },
    contact_numbers: ContactNumber[];
}

export interface ClientSingleResponse {
    data: Client;
}

export interface StoreClientRequest {
    reference: string;
    nhs_number: string;
    email: string;
    status?: boolean;

    person: StorePersonRequest;
    contact_numbers_to_store?: StoreContactNumberRequest[];
}

export function createClientDetailsFormGroup(clientData?: Client) {
    return new FormGroup({
        reference: new FormControl<string>(clientData?.reference ?? '', [
            Validators.required,
            Validators.minLength(2),
            Validators.maxLength(50)
        ]),
        nhs_number: new FormControl<string>(clientData?.nhs_number ?? '', [
            Validators.required,
            Validators.minLength(10),
            Validators.maxLength(10)
        ]),
        email: new FormControl<string>(clientData?.email ?? '', [
            Validators.email
        ])
    });
}
